import React, { useEffect, useState } from "react";
import classNames from "classnames/bind";
import { Pagination, Table as TB } from "../../../components";
import Filter from "./Filter/Filter";
import { formatDate, formatDateToTime, formatDB, sorterArray } from "../../../utils";
import axiosClient from "../../../services/axiosClient";
import styles from "./Stream.module.css";
import NameCol from "../../../components/NameCol";
import Nodata from "../NoData/Nodata";

const cx = classNames.bind(styles);
const Stream = () => {
  const [stream, setStream] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [textSearch, setTextSearch] = useState();
  const [toggleSort, setToggleSort] = useState(false)
  const [dataTable, setDataTable] = useState()
  const [method, setMethod] = useState('')
  const handleClick = (page) => {
    setCurrentPage(page);
  };
  const handleNext = () => {
    setCurrentPage(currentPage + 1);
  };
  const handlePrevious = () => {
    setCurrentPage(currentPage - 1);
  };
  const onChangeTextSearch = (data) => {
    setTextSearch(data);
    setCurrentPage(1)
  };
  useEffect(() => {
    async function getHistoryStream() {
      const date =
        startDate && endDate
          ? {
            day_start: formatDB(startDate),
            day_end: formatDB(endDate),
          }
          : {};
      const res = await axiosClient.get("/viewHistory/get-list-view-history/", {
        params: {
          page: currentPage,
          size: 10,
          ...date,
          username: textSearch,
          action_code: "CODE_4"
        },
      });
      if (res.count) {
        setPages(Math.ceil(res.count / 10));
      } else {
        setPages(1);
      }
      setStream(res.data);
    }
    getHistoryStream();
  }, [currentPage, textSearch, endDate, startDate]);
  const onChangeDateStart = (data) => {
    setStartDate(data);
  };
  const onChangeDateEnd = (data) => {
    setEndDate(data);
  };

  useEffect(() => {
    const newData = stream.length > 0 ? [...stream] : null
    if (newData && method.length > 0) {
      switch (toggleSort) {
        case 'up':
          const dataSortUp = sorterArray(newData, method)
          setDataTable(dataSortUp)
          break;
        case 'down':
          const dataSortDown = sorterArray(newData, method)
          setDataTable(dataSortDown.reverse())
          break;
        default:
          setDataTable(newData)
          break;
      }
    } else {
      setDataTable(newData)
    }
  }, [stream, toggleSort, method])

  const handleSort = (type, method) => {
    if (type !== toggleSort) {
      setToggleSort(type)
      setMethod(method)
    } else {
      setToggleSort(false)
      setMethod('')
    }
  }

  useState(() => {
    const dateNow = new Date()
    const time = formatDate(dateNow)
    setStartDate(time);
    setEndDate(time)
  }, [])

  const dataSource = dataTable?.map((item, index) => {
    return {
      stt: index + 1,
      date: formatDateToTime(item.TIME),
      username: item.USERNAME,
      action: item?.ACTION_NAME,
      object: item?.CAMERA_CODE,
    };
  });

  const columns = [
    {
      label: "STT",
      key: "stt",
    },
    {
      label: <NameCol active={method} title={'Tài khoản'} handleSort={handleSort} method={'USERNAME'} />,
      key: "username",
    },
    {
      label: <NameCol active={method} title={'Hành động'} handleSort={handleSort} method={'ACTION_NAME'} />,
      key: "action",
    },
    {
      label: <NameCol active={method} title={'Đối tượng'} handleSort={handleSort} method={'CAMERA_CODE'} />,
      key: "object"
    },
    {
      label: <NameCol active={method} title={'Thời gian'} handleSort={handleSort} method={'TIME'} />,
      key: 'date'
    },
  ];
  return (
    <>
      <div className={cx("header")}>
        <h1 className={cx("title")}>Lịch sử xem trực tiếp</h1>
      </div>
      <div className={cx('content')}>
        <Filter
          changeTextSearch={onChangeTextSearch}
          dayStart={startDate}
          dayEnd={endDate}
          onChangeDayStart={onChangeDateStart}
          onChangeDayEnd={onChangeDateEnd}
        />
        <TB data={dataSource} colum={columns} />
        {dataSource?.length > 0 ?  <div className={cx("pagination")}>
          <Pagination
            onClick={handleClick}
            onNext={handleNext}
            onPrevious={handlePrevious}
            pages={pages}
            currentPage={currentPage}
          />
        </div>:<Nodata/>}
      </div>
    </>
  );
};

export default Stream;
